const reviews: Array<Reviews> = [
    {
        id: 1,
        fname: 'string',
        lname: 'string',
        rate: 4,
        email: 'string',
        message: 'string',
        phone: 324234,
    },

    {
        id: 1,
        fname: 'Daniel',
        lname: 'Nashed',
        rate: 4,
        email: 'daniel@hot.com',
        message: 'heloodsf sdkfjlsj',
        phone: 324234
    },

    {
        id: 1,
        fname: 'h',
        lname: 'Nashed',
        rate: 4,
        email: 'string',
        message: 'string',
        phone: 324234

    },


   ]

export {reviews};